import { Box } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import moment from 'moment'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useParams } from 'react-router'
import api from '../../../../components/services/api'

export default function ContainerDemand() {
    const {id} = useParams()
    const [data, setData] = useState([])
    const getData = async () => {
        try {
          const data = await api.get(`api/stock/detail/demand/${id}`);
          setData(data.data);
        } catch (e) {
          console.log(e);
        }
      };
      useEffect(() => {
        getData()
      },[])
    const columns = [
        { field: "ContainerStockType", headerName: "Status", width: 100 },
        { field: "SaleOrderNo", headerName: "Sale Order No.", width: 200 },
        { field: "BookingNo", headerName: "Booking No.", width: 200 },
        { field: "Size", headerName: "Size", width: 100 },
        { field: "Quantity", headerName: "Quantity", width: 100 },
        { field: "Forwarding", headerName: "Forwarding", width: 100 },
        { field: "CustomerName", headerName: "Customer Name", width: 200 },
        { field: "ShipperRefNo", headerName: "Shipper Ref No.", width: 200 },
        { field: "Commodity", headerName: "Commodity", width: 100 },
        { field: "Package", headerName: "Package", width: 100 },
        { field: "Stuffing", headerName: "Stuffing", width: 100 },
        { field: "InboundGateOut", headerName: "Gate OUT", width: 150 },
        { field: "InboundGateIn", headerName: "Gate IN", width: 150 },
        { field: "VoyOut", headerName: "VOY OUT", width: 150 },
        { field: "OutboundETDGateOut", headerName: "ETD Gate OUT", width: 150,valueFormatter: ({ value }) => {
            return value ?  moment(value).format("DD-MM-YYYY") : '';
          }, },
        { field: "OutboundETAGateIn", headerName: "ETA Gate IN", width: 150,valueFormatter: ({ value }) => {
            return value ?  moment(value).format("DD-MM-YYYY") : '';
          }, },
    ]
    return (
        <Box
            sx={{
                height: 630,
                width: "100%",
                marginTop: "10px",
                // "& .Active": {
                //     color: "#28A745",
                // },
                // "& .Inactive": {
                //     color: "#F53C56",
                // },
            }}
        >
            <DataGrid
                getRowId={(r) => r.SaleOrderNo}
                rows={data}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[10]}
                hideFooterSelectedRowCount
                disableColumnFilter
                disableColumnMenu
            // getCellClassName={(params) => {
            //     if (params.field === "Status") {
            //         return params.value == 1 ? "Active" : "Inactive";
            //     }
            // }}

            />
        </Box>
    )
}
